import { makeAutoObservable, action, computed, toJS, extendObservable, set } from 'mobx';
import domainData from 'store/domainStore';
import tableOptions from 'pages/wineLovers/config/config';
import { getInitialParams, saveParamsToStorage } from './common/filterUtils';

const STORAGE_KEY = 'wine_lovers_filter_params';

// Default filter parameters
const defaultFilterParams = {
  params: {
    sort: {
      field: 'createdAt',
      order: 'desc',
    },
    filter: {},
    limit: 100,
    skip: 0,
    search: {
      value: '',
      fields: [],
    },
  },
};

class WineLovers {
  getDefaultStoreProps = () => ({
    wineLovers: {
      count: 0,
      data: [],
    },
    filterData: defaultFilterParams,
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  reset() {
    set(this, this.getDefaultStoreProps());
  }

  @action
  setStoreWineLovers(newData) {
    this.wineLovers.data = [];
    newData.data.forEach(this.addStoreWineLovers);
    this.wineLovers.count = newData.count;
  }

  @action
  addStoreWineLovers = element => {
    this.wineLovers.data.push(element);
  };

  @action
  setFilter(filter) {
    this.filterData = filter;
    // Save to localStorage using common utility, but exclude search
    if (filter?.params) {
      const { search: _search, ...paramsWithoutSearch } = filter.params;
      const filterToSave = {
        ...filter,
        params: paramsWithoutSearch,
      };
      saveParamsToStorage(STORAGE_KEY, filterToSave);
    }
  }

  @action
  resetFilters() {
    this.setFilter(defaultFilterParams);
  }

  // Get current filter parameters using common utility with validation
  getCurrentFilterParams = (urlParams = {}) => {
    const isUserSuperAdmin = domainData.userIsSuperAdmin();
    const subscriptionAccess = domainData.getSubscriptionAllAccess();
    const userContext = { isUserSuperAdmin, subscriptionAccess };

    return getInitialParams(STORAGE_KEY, defaultFilterParams, tableOptions.wineLover, userContext, urlParams);
  };

  @computed
  get filter() {
    const filterToJS = toJS(this.filterData);
    return filterToJS;
  }
}

export default new WineLovers();
